<template>
  <material-card class=pt-2 full-header>
    <template #heading>
      <v-toolbar color="accent">
        <v-toolbar-title>
          <v-icon> mdi-google-classroom </v-icon>
          {{ tableTitle }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn text icon dark class="mb-2" @click="close">
          <v-icon medium>mdi-close-circle-outline</v-icon>
        </v-btn>
      </v-toolbar>
    </template>

    <v-data-table :items="meetingList" :headers="meetingsHeader" :loading="loading" item-key="meetingID"
      :search="search" show-expand single-expand :expanded.sync="expanded" :footer-props="{ showFirstLastPage: true}">
      <template v-slot:top>
        <v-toolbar>
          <v-toolbar-title>
            <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('search')" single-line hide-details>
            </v-text-field>
          </v-toolbar-title>
          <v-divider vertical></v-divider>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text icon dark class="mb-2" v-bind="attrs" v-on="on" color="primary" @click="getMeetings">
                <v-icon medium>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t("refresh") }}
            </span>
          </v-tooltip>
        </v-toolbar>
      </template>
      <!-- custom columns -->
      <template v-slot:[`item.attendeePW`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="ma-2" text icon v-bind="attrs" v-on="on">
              <v-icon color="primary" medium @click="joinMeeting(item, 'at')">mdi-account-school-outline</v-icon>
            </v-btn>

          </template>
          <span>{{ $t("join_as_attendee") }}</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.running`]="{ item }">
        <span>{{ $t(item.running) }}</span>
      </template>
      <template v-slot:[`item.meetingName`]="{ item }">
        <span>{{ $t(item.meetingName) }}</span><br>
        <span>{{ item.metadata['company-name'] }}-{{ item.metadata['mobile'] }}</span>
      </template>
      <template v-slot:[`item.recording`]="{ item }">
        <span>{{ $t(item.recording) }}</span>
      </template>
      <template v-slot:[`item.moderatorPW`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="ma-2" text icon v-bind="attrs" v-on="on">
              <v-icon color="primary" medium @click="joinMeeting(item, 'md')">mdi-human-male-board-poll</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("join_as_moderator") }}</span>
        </v-tooltip>
      </template> 
      <template v-slot:[`item.dashboard`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="ma-2" text icon v-bind="attrs" v-on="on" :loading="learningDashboardLoading">
              <v-icon color="primary" medium @click="openLearningDashboard(item)">mdi-monitor-dashboard</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("dashboard") }}</span>
        </v-tooltip>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <BBBMeetingUsers :key="item.meetingID"
            :users="(Array.isArray(item.attendees.attendee) ? item.attendees.attendee : [{ ...item.attendees.attendee }])">
          </BBBMeetingUsers>
        </td>
      </template>
    </v-data-table>
    <template #actions>

    </template>
  </material-card>
</template>
<script>
export default {
  name: "BBBLiveMeetings",
  props: {
    visible: Boolean,
    serverData: {
      type: Object,
      default: {}
    }
  },
  computed: {
    tableTitle() {
      return (this.serverData.service_name == "bigbluebutton" ?
        this.$t("bigbluebutton_meetings") :
        this.$t("loadbalancer_meetings"))
        + this.serverData.domain;

    }
  },
  data() {
    return {

      meetingsHeader: [
        { text: '', value: 'data-table-expand' },
        { value: "meetingName", text: this.$t("meeting_name") },
        { value: "duration", text: this.$t("duration") },
        { value: "running", text: this.$t("running") },
        { value: "recording", text: this.$t("recording") },
        { value: "participantCount", text: this.$t("participant_count") },
        { value: "voiceParticipantCount", text: this.$t("voice_participant_count") },
        { value: "videoCount", text: this.$t("video_count") },
        { value: "listenerCount", text: this.$t("listener_count") },
        { value: "moderatorCount", text: this.$t("moderator_count") },
        { value: "attendeePW", text: this.$t("join_as_attendee") },
        { value: "moderatorPW", text: this.$t("join_as_moderator") },
        { value: "dashboard", text: this.$t("dashboard") },
      ],
      meetingList: [],
      loading: true,
      totalServers: 0,
      options: {},
      itemPerPage: 10,
      pageNumber: 1,
      startRow: 0,
      endRow: 10,
      joinLoading: false,
      search: '',
      expanded: [],
      learningDashboardLoading:false,
    };
  },
  watch: {
    options: {
      handler() {
        this.getMeetings();
      },
      deep: true,
    },
  },
  methods: {
    getMeetings() {
      this.loading = true;
      axios({
        url: process.env.VUE_APP_BACKEND_URL + "/api/virtual_machine/" + this.serverData.id,
        method: "GET",
        headers: {
          Authorization: this.$store.get("login/token"),
        },
      })
        .then((response) => {
          let data = response.data.data.meeting;
          if (data == undefined) return;
          this.meetingList = (Array.isArray(data) ? data : [{ ...data }]);
          this.loading = false;
        })
        .catch((error) => {
          console.log('error', error);
        }).finally(() => {
          this.loading = false;
        });
    },
    joinMeeting(meeting, userType) {
      this.joinLoading = true;
      axios({
        url: process.env.VUE_APP_BACKEND_URL + "/api/virtual_machine/" + this.serverData.id + "/join",
        method: "GET",
        headers: {
          Authorization: this.$store.get("login/token"),
        },
        params: {
          meetingID: meeting.meetingID, fullName: 'Admin',
          password: (userType == 'at' ? meeting.attendeePW : meeting.moderatorPW), redirect: "true"
        }
      })
        .then((response) => {
          window.open(response.data.link, '_blank');
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        }).finally(() => {
          this.joinLoading = false;
        });
    }
    ,
    close() {
      this.$emit('close')
    },
    openLearningDashboard(item){
      this.learningDashboardLoading=true;
      axios({
        url: process.env.VUE_APP_BACKEND_URL + "/api/command/bigbluebutton/learning_dashboard/" + this.serverData.id ,
        method: "GET",
        headers: {
          Authorization: this.$store.get("login/token"),
        },
        params: {
          meetingId: item.internalMeetingID
        }
      })
      .then((response) => {
        const routeData = this.$router.resolve({name: 'dashboard', params: {'url': response.data.url}});
        console.log(routeData);
          window.open("/learningDashboard?url="+response.data.url, '_blank');
        })
        .catch((error) => {
          console.log(error);
        }).finally(() => {
          this.learningDashboardLoading = false;
        });
    }
  },
  mounted() {
    this.getMeetings();
  },
};
</script>
<style>
.text-content-left input {
  text-align: left !important;
}
</style>
  